// extracted by mini-css-extract-plugin
export default {"head":"PageReceive_head__fct3r","body":"PageReceive_body__VuA8h","button":"PageReceive_button__E+HGl"};